const cardBlacklist = {
  header: {
    btnCreate: 'Erstellen',
  },

  forms: {
    header: {
      create: {
        title: 'Erstellen',
      },
      update: {
        title: 'Aktualisieren',
      },
    },
    create: {
      success: 'Auf der Blacklist stehende Karte wurde hinzugefügt!',
      failure: 'Es konnte keine Karte auf der Blacklist erstellt werden.',
      header: 'Karten-Black-List-Element erstellen',
      footer: {
        submit: 'Einreichen',
      },
    },
    update: {
      footer: {
        submit: 'Aktualisieren',
      },
    },
    sections: {
      details: {
        header: 'Details',
        fields: {
          number: 'Kartennummer',
        },
      },
    },
  },
  table: {
    headers: {
      number: 'Kartennummer',
      site: 'Bereich',
    },
    actions: {
      delete: {
        modal: {
          header: 'Löschen Sie Karten auf der Blacklist',
          body: 'Sie sind dabei, {{num}} Karten auf der Blacklist zu löschen.',
        },
        success: 'Auf der Blacklist stehende Karten wurden erfolgreich gelöscht',
      },
      create: 'Erstellen',
    },
    floatingActions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    
  },
};

export default cardBlacklist;
